import confetti from 'canvas-confetti';

export const triggerConfetti = () => {
    const canvasSettings = {
        zIndex: 9999,  // Ensure confetti appears above the modal
        resize: true,
        disableForReducedMotion: true
    };

    // First burst - from bottom center
    confetti({
        ...canvasSettings,
        particleCount: 100,
        spread: 70,
        origin: { y: 0.9, x: 0.5 },
        colors: ['#FFD700', '#FFA500', '#FF69B4', '#00FF00', '#4169E1']
    });

    // Side bursts after a small delay
    setTimeout(() => {
        // Left side burst
        confetti({
            ...canvasSettings,
            particleCount: 50,
            angle: 60,
            spread: 55,
            origin: { x: 0, y: 0.65 }
        });

        // Right side burst
        confetti({
            ...canvasSettings,
            particleCount: 50,
            angle: 120,
            spread: 55,
            origin: { x: 1, y: 0.65 }
        });
    }, 250);

    // Random bursts
    const duration = 2000;
    const end = Date.now() + duration;

    const interval = setInterval(() => {
        if (Date.now() > end) {
            return clearInterval(interval);
        }

        confetti({
            ...canvasSettings,
            particleCount: 30,
            angle: 90,
            spread: 70,
            origin: { x: Math.random(), y: 0.8 },
            colors: ['#FFD700', '#FFA500', '#FF69B4', '#00FF00', '#4169E1']
        });
    }, 200);
}; 